import React from 'react';
import { motion } from 'framer-motion';
export const Divider = () => {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.8
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="flex items-center justify-center py-16 opacity-70" data-id="element-169">
      <div className="h-[1px] w-16 bg-gradient-to-r from-transparent via-gold-muted to-transparent" data-id="element-170" />
      <div className="mx-4 rotate-45 w-2 h-2 border border-gold-muted" data-id="element-171" />
      <div className="h-[1px] w-16 bg-gradient-to-l from-transparent via-gold-muted to-transparent" data-id="element-172" />
    </motion.div>;
};